import { Component, OnInit, Inject, ViewChild, TemplateRef, OnDestroy, ElementRef } from '@angular/core';
import { TranslationService } from '../../common/services/translation.service';
import { DataTableFilter, FilterType, FilterOperator, RowChanges } from '../../common/models/DataTableFilter.model';
import { IColumn, CellType } from '../../common/interfaces/IColumn.interface';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { SpinnerService } from '../../../app-module/spinner/spinner.service';
import { IPagedDataTable } from '../../common/interfaces/IPagedDataTable.interface';
import {SystemCertificatesDataTableService} from "../../../security-module/certificate-management/certificate-management/system-certificates-tab/system-certificates-data-table.service";
import {SystemCertificateTableRow} from "../../../security-module/certificate-management/certificate-management.model";
import {CurrentUser} from "../../common/services/current-user.service";

@Component({
    selector: 'cpq-active-client-system-certificate-data-table-dialog',
    templateUrl: './cpq-active-client-system-certificate-data-table-dialog.component.html',
    styleUrls: ['./cpq-active-client-system-certificate-data-table-dialog.component.scss'],
    providers: [SystemCertificatesDataTableService],
    standalone: false
})

export class CpqActiveClientSystemCertificateDataTableDialogComponent implements OnInit, OnDestroy {
  public filter: DataTableFilter;
  public totalCount: number;
  public columns = new Array<IColumn>();
  public guid: string;
  private selectedCertificate = null;
  @ViewChild('selectTmpl', { static: true }) selectTmpl: TemplateRef<any>;
  @ViewChild('systemCertificateDataTableDialog', { static: true }) dialog: ElementRef;

  constructor(
    public service: SystemCertificatesDataTableService,
    private translateService: TranslationService,
    public spinnerService: SpinnerService,
    private currentUser: CurrentUser,
    @Inject(MAT_DIALOG_DATA) public data: SystemCertificateTableRow | any,

    public dialogRef: MatDialogRef<CpqActiveClientSystemCertificateDataTableDialogComponent>) {
  }

  ngOnInit() {
    this.initColumns();
    this.initFilter();
    this.validateGuid(this.data.guid);
    this.guid = this.data.guid;
  }

  private initFilter() {
    this.filter = new DataTableFilter(this.currentUser);
    this.filter.placeholder = 'Admin.CertificateManagement.FindByNameOrSoapUrl';
    this.filter.totalCountPlaceholder = 'Admin.CertificateManagement.TotalCertificates';
    this.filter.filters.push(
      {
        name: 'name'
      },
      {
        name: 'issuer'
      },
      {
        name: 'validFrom',
        type: FilterType.Date,
        operator: FilterOperator.BiggerOrEqual
      },
      {
        name: 'validTo',
        type: FilterType.Date,
        operator: FilterOperator.SmallerOrEqual
      },
      {
        name: 'purpose',
        type: FilterType.Select,
        source: [
          { id: '1', text: 'OutboundSOAPHeaderSigning' },
          { id: '4', text: 'InboundSOAPHeaderSigning' }
        ],
        value: '5'
      },
      {
        name: 'soapUrl'
      },
      {
        name: 'thumbprint'
      },
      {
        name: 'active',
        type: FilterType.Select,
        source: [
          { id: '1', text: this.translateService.translate('Msg.Yes') },
          { id: '0', text: this.translateService.translate('Msg.No') }
        ],
        value: '1'
      }
    );
  }

  private initColumns() {
    this.columns = [
      {
        cellTemplate: this.selectTmpl,
        cellType: CellType.custom,
        name: this.translateService.translate('Admin.CertificateManagement.SelectCertificate'),
        prop: 'selected',
        editable: true,
        visible: true,
        sortable: false,
        minWidth: 150,
        maxWidth: 150,
        width: 150
      },
      {
        prop: 'selector',
        name: this.translateService.translate('xsltName'),
        visible: true
      },
      {
        prop: 'issuer',
        name: this.translateService.translate('Admin.CertificateManagement.Issuer'),
        visible: true
      },
      {
        prop: 'validFrom',
        name: this.translateService.translate('Admin.CertificateManagement.ValidFrom'),
        visible: true
      },
      {
        prop: 'validTo',
        name: this.translateService.translate('Admin.CertificateManagement.ValidTo'),
        visible: true
      },
      {
        prop: 'soapUrl',
        name: this.translateService.translate('Admin.CertificateManagement.SoapUrl'),
        visible: true
      },
      {
        prop: 'thumbprint',
        name: this.translateService.translate('Admin.CertificateManagement.Thumbprint'),
        visible: false
      }
    ];
  }

  private validateGuid(guid: string) {
    if (!guid) {
      throw new RangeError('You can not provide empty guid');
    }
  }

  ngOnDestroy() {
  }

  public onRowsChanged(pagedData: IPagedDataTable<SystemCertificateTableRow>) {
    this.totalCount = pagedData.totalNumberOfRecords;
  }

  cancel() {
    this.dialogRef.close(null);
  }

  public onRowChanged(rowChanges: RowChanges) {
    this.selectedCertificate = rowChanges.modifiedRows.filter(certificate => certificate.selected === true)[0];
  }

  public save(row?: SystemCertificateTableRow) {
    this.dialogRef.close(row ? row : this.selectedCertificate);
  }
}
